module.exports = __webpack_public_path__ + "static/img/icon-sofa-dark.0ec5f1f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/icon-sofa-dark.png
// module id = 1030
// module chunks = 35